import React from "react";
import Sidebar from "../components/Sidebar";

const Analytics: React.FC = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 p-8">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">วิเคราะห์ข้อมูล</h1>
          <p className="text-gray-600 mb-6">ข้อมูลและสถิติของธุรกิจ</p>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">ยอดขายรวม</p>
              <p className="text-2xl font-bold text-gray-900">฿1,234,567</p>
              <p className="text-sm text-green-600">+15.3%</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">คำสั่งซื้อ</p>
              <p className="text-2xl font-bold text-gray-900">1,847</p>
              <p className="text-sm text-green-600">+23.5%</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">ผู้เยี่ยมชม</p>
              <p className="text-2xl font-bold text-gray-900">12,847</p>
              <p className="text-sm text-green-600">+12.3%</p>
            </div>
            <div className="bg-white rounded-lg shadow p-4 border border-gray-200">
              <p className="text-sm text-gray-600">อัตราการแปลง</p>
              <p className="text-2xl font-bold text-gray-900">3.2%</p>
              <p className="text-sm text-yellow-600">-0.5%</p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">ยอดขายรายเดือน</h2>
              <div className="h-64 bg-gray-50 rounded-lg flex items-center justify-center">
                <p className="text-gray-500">แผนภูมิยอดขาย</p>
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">สินค้าขายดี</h2>
              <div className="space-y-4">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">หูฟังไร้สาย</span>
                  <span className="text-sm font-medium text-gray-900">฿58,500</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">สมาร์ทวอทช์</span>
                  <span className="text-sm font-medium text-gray-900">฿45,360</span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">USB-C Hub</span>
                  <span className="text-sm font-medium text-gray-900">฿23,400</span>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">แหล่งที่มาของลูกค้า</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600">ค้นหาออร์แกนิก</p>
                <p className="text-xl font-bold text-gray-900">45%</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600">โซเชียลมีเดีย</p>
                <p className="text-xl font-bold text-gray-900">30%</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600">โฆษณา</p>
                <p className="text-xl font-bold text-gray-900">15%</p>
              </div>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-sm text-gray-600">อื่นๆ</p>
                <p className="text-xl font-bold text-gray-900">10%</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
